import React, { useState } from "react";
import "./AvatarMenu.scss";
import { Menu, MenuItem, Box, Typography } from "@mui/material";
import user from "../../assets/icons/user.svg";
import CustomButton from "../../components/v2/custom-button/CustomButton";
import { ActiveLanguages } from "../../utility/interfaces/masterDataInterfaces";
import CustomLanguage from "../../components/v2/custom-language-selector/CustomLanguageSelector";
import { useTranslation } from "react-i18next";

interface AvatarMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  onProfileClick: () => void;
  onLanguageClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  selectedLanguage: string;
  avatarLabel: string;
  unitedIcon: string;
  supportedLanguages: [];
  onChangeLang: (selectedLang: ActiveLanguages) => void;
  onLogoutClick: () => void;
}

const AvatarMenu: React.FC<AvatarMenuProps> = ({
  anchorEl,
  open,
  onClose,
  onProfileClick,
  onLanguageClick,
  selectedLanguage,
  unitedIcon,
  supportedLanguages,
  onChangeLang,
  onLogoutClick,
}) => {
  const [languageAnchorEl, setLanguageAnchorEl] = useState<null | HTMLElement>(
    null
  );
  const isLanguageMenuOpen = Boolean(languageAnchorEl);
  const { t } = useTranslation();

  const handleLanguageClick = (event: React.MouseEvent<HTMLElement>) => {
    setLanguageAnchorEl(event.currentTarget);
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      MenuListProps={{
        className: "avatar-menu",
        "aria-labelledby": "menu-button",
      }}
      slotProps={{
        paper: {
          className: "avatar-menu-paper",
        },
      }}
    >
      <MenuItem
        className="menu-item-style"
        onClick={() => {
          onProfileClick();
          onClose();
        }}
      >
        <Box className="profile-item">
          <img
            src={user}
            alt={t("myProfile")}
            className="profile-image" // Using the class here
          />
          <Typography>{t("myProfile")}</Typography>
        </Box>
      </MenuItem>

      <Box className="separator"></Box>

      <MenuItem
        className="menu-item-style"
        onClick={() => {
          onClose();
        }}
      >
        <Box className="logout-button">
          <CustomButton
            variant="outlined"
            text={t("logout")}
            onClick={onLogoutClick}
          />
        </Box>
      </MenuItem>

      {/* Language Selector component */}
      <CustomLanguage
        onLangMenuOpen={handleLanguageClick}
        selectedLanguage={selectedLanguage}
        anchorEl={languageAnchorEl}
        open={isLanguageMenuOpen}
        onClose={() => setLanguageAnchorEl(null)}
        supportedLanguages={supportedLanguages}
        onChangeLang={onChangeLang}
      />
    </Menu>
  );
};

export default AvatarMenu;
